import {createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserProfile, refreshUserToken } from '../pages/Sign/utils';
import { RootState } from './store';

export interface UserState {
  siteLang: 'en' | 'ar';
  user: any
  isValidating: boolean,
}

const initialState: UserState = {
  siteLang: (localStorage.getItem('romotors_web_lang') as 'en' | 'ar') || 'en',
  isValidating: true,
  user: null,
};

export const persistLoggedUser = createAsyncThunk("user/login", async (_, {rejectWithValue}) => {
  const currentToken = JSON.parse(
    localStorage.getItem("romotors_web_credentials") || '""'
  );
  let expiration = Date.now();
  if (currentToken) expiration = currentToken.expires_in;
  if (expiration > Date.now()) {
    return await getUserProfile().then(res => res.data.profile).catch(() => rejectWithValue('error'));
  } else if (currentToken.refresh_token) {
    return await refreshUserToken(currentToken.refresh_token).then(async (res) => {
      localStorage.setItem('romotors_web_credentials', JSON.stringify({
        access_token: res.data.access_token,
        expires_in: Date.now() + res.data.expires_in,
        refresh_token: res.data.refresh_token,
      }));
      return await getUserProfile().then(res => {
        return res.data.profile
      }).catch(() => {
        return rejectWithValue('error')
      })
    }).catch(() => {
      return rejectWithValue('error')
    })
  } else {
    return rejectWithValue('error')
  }
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload
      }
    },
    logUserOut: (state) => {
      localStorage.removeItem('romotors_web_credentials')
      state.user = null
    }
  },
  extraReducers: builder => {
    builder.addCase(persistLoggedUser.pending, (state) => {
      state.isValidating = true;
    });
    builder.addCase(persistLoggedUser.fulfilled, (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload,
      };
      state.isValidating = false;
    });
    builder.addCase(persistLoggedUser.rejected, (state) => {
      state.user = null
      state.isValidating = false;
    });
  }
});

export const { setUserData, logUserOut } = userSlice.actions;

export const selectSiteLang = (state: RootState) => state.user.siteLang;

export const selectUser = (state: RootState) => state.user;

export const changeSiteLang = (target: 'en' | 'ar') => {
  localStorage.setItem('romotors_web_lang', target);
  window.location.reload();
}

export default userSlice.reducer;
